<h2 class="space-v-m" *ngIf="totalElements">
  {{ totalElements }}
  {{ totalElements === 1 ? ('PARTNERS.SEARCH.RESULT_FOUND' | translate) : ('PARTNERS.SEARCH.RESULTS_FOUND' | translate) }}
</h2>
<app-data-table
  [columnConfigs]="columnConfigs"
  [tableData]="dataSource"
  [displayInfo]="displayInfo"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [tableName]="'partners'"
  [defaultSortActive]="'name'"
  [defaultSortDirection]="'asc'"
  (filterChanged)="onFilterChanged($event)"
>
</app-data-table>
